/* eslint-disable camelcase */
import { Input, SimpleGrid } from '@chakra-ui/react';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useInitiatives } from '@services/query-services/initiatives.query-service';
import { useUserStore } from '@store/app.store';
import CustomSelect from '@components/general/form/custom-select.component';
import FilterItem from '@components/feed/feed-filter-item.component';

/**
 * Modal-friendly version of FeedFilterAccordion
 * Uses react-hook-form context for form state management
 */
function CardSearchFilterAccordion() {
  const { control, register } = useFormContext();
  const user = useUserStore((state) => state?.user);
  const tenant = useUserStore((state) => state.tenant);
  const isGuest = user?.isGuest;

  const { data: allLabels } = useInitiatives(
    {
      type: 'Label',
      has_archived_at: false,
      tenant_id: tenant?.id,
      pageSize: 100
    },
    { enabled: !!(user && !isGuest) }
  );

  return (
    <SimpleGrid
      columns={{ base: 1, lg: 2 }}
      spacing={4}
      alignItems='start'
    >
      <FilterItem text='Keyword'>
        <Input
          size='sm'
          w='full'
          fontSize='sm'
          h={10}
          {...register('keyword')}
          borderRadius='md'
          placeholder='Enter a keyword'
          _placeholder={{
            color: 'surface.outline',
            p: 0.5,
            ml: 1,
            textStyle: 'body-500-sm'
          }}
        />
      </FilterItem>
      {!isGuest && (
        <FilterItem text='Labels'>
          <Controller
            name='labels'
            control={control}
            render={({ field: { onChange, value } }) => (
              <CustomSelect
                size='md'
                selectProps={{ width: '100%' }}
                placeholder='Type or select a label'
                options={allLabels}
                getOptionLabel={(opt) => opt?.title}
                getOptionValue={(opt) => opt?.id}
                onChange={(e) => {
                  onChange(e.map((label) => label?.id));
                }}
                value={allLabels?.filter((label) => value?.includes(label?.id))}
                menuPlacement='auto'
              />
            )}
          />
        </FilterItem>
      )}
    </SimpleGrid>
  );
}

export default memo(CardSearchFilterAccordion);
